<template>
  <div id="app">
    <div id="header" v-if="site">
      <div class="row">
        <div class="col-sm-6">
          <div id="logo">
            <router-link :to="{ name: 'Index'}"><img :src="site.logo"></router-link>
          </div>
        </div>
        <div class="col-sm-6">
          <div id="contacts">
            <div id="phone" v-if="site.phone"><i class="icon-phone"></i> {{site.phone}}</div>
            <div id="email" v-if="site.email"><i class="icon-email"></i> {{site.email}}</div>
            <div id="site-url" v-if="site.domain"><a :href="'https://'+site.domain">{{site.domain}}</a></div>
          </div>
        </div>
      </div>

    </div>

    <router-view :slogan="123"/>

    <div id="footer" v-if="site">
      &copy; {{current_date.getFullYear()}} {{site.name}}
    </div>
  </div>
</template>


<script>

export default {
  name: 'App',
  data () {
      return {
          site: null,
          current_date: new Date()
      }
  },

  mounted: function() {
      this.getSite()
  },
  methods: {
      getSite() {
          axios.get(this.$conf.apiHost+'/api/faq/sites/'+this.$conf.siteId+'?site='+this.$conf.siteId).then((response) => {

              this.site = response.data.data;

              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = '/static/themes/'+this.site.theme_id+'/css/styles.css';
              document.head.appendChild(link);


          });
      },
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue